import {
  Avatar,
  Box,
  Image,
  Input,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { AiOutlineEdit, AiOutlinePlus, AiOutlineSetting } from "react-icons/ai";
import { BsCheckCircle, BsPencil } from "react-icons/bs";
import { IoChatbubbles } from "react-icons/io5";
import { IoMdCheckmark } from "react-icons/io";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetState } from "../../context/useGetState";
import { photoBaseURL } from "../../service/api";
import ProfileBox from "./components/ProfileBox";
import http, { AUTH_ROUTES } from "../../service/api";
import thelogo from "../../assets/thelogo.png"
import {
  errorNotifier,
  LoadingMessage,
  shortNotifier,
  successNotifier,
} from "../..";
import { follow, getFollowingUsers, getMyfollowers, unFollow } from "../../pages/dashboard/discover/service";
import { BiImageAdd } from "react-icons/bi";
import { FiPlus } from "react-icons/fi";
import UpdatePostImageBackground from "./UpdatePostImageBackground";
import AboutModal from "./AboutModal";
import FollowersModal from "./components/FollowersModal";
import FollowingModal from "./components/FollowingModal";
import SocialMediaModal from "./SocialMediaModal";
import MyGroupCard from "./components/MyGroupCard";
import Fancybox from "../../pages/dashboard/discover/stories/Fancybox";
import FsLightbox from "fslightbox-react";
//import FsLightbox from "fslightbox-react";

// Utility function to format large numbers (e.g., 1000 -> 1K, 1000000 -> 1M)
export function nFormatter(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num;
}

function ProfileOverview(props) {
  let { id } = useParams();
  const { state } = useGetState();
  const { state: externalProfileInfo } = useLocation();

  // // To open the lightbox change the value of the "toggler" prop.
	// const [toggler, setToggler] = useState(false);

  // console.log('toggler: ', toggler);

  // Now you can access externalProfileInfo to get the passed state
  const discoverUserInfo = externalProfileInfo?.user ? externalProfileInfo?.user : null; // Assuming 'userInfo' is part of the passed state

  const [profileInfo, setProfileInfo] = useState({});
  const [, setBtnLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const isLoggedIn = typeof state?.userInfo === "object" ? true : false;

  const navigate = useNavigate();
  const [socialMediaAccounts, setSocialMediaAccounts] = useState([
    { title: "Facebook", color: "#0076FF", link: "" },
    { title: "Instagram", color: "#E12784", link: "" },
    { title: "Twitter", color: "#00C2FF", link: "" },
    { title: "Telegram", color: "#009274", link: "" },
  ]);
  const imageRef = useRef();

  // const [about, setAbout] = useState(
  //   state?.userInfo?.about ? state?.userInfo?.about : "not available"
  // );
  const [editAbout, setEditAbout] = useState(false);
  const [editSocialMedia, setEditSocialMedia] = useState(false);
  const imgRef1 = useRef();
  const imgRef2 = useRef();
  const imgRef3 = useRef();
  const imgRef4 = useRef();
  const imgRef5 = useRef();
  const imgRef6 = useRef();
  const [posts, setPosts] = useState([]);
  const [isUpdatePost, setIsUpdatePost] = useState(null);
  const [aboutModalOpen, setAboutModalOpen] = useState(false);
  const [followersModalOpen, setFollowersModalOpen] = useState(false);
  const [followingModalOpen, setFollowingModalOpen] = useState(false);
  const [socialMediaModalOpen, setSocialMediaModalOpen] = useState(false);
  const [allFollowingUsers, setAllFollowingUsers] = useState([]);
  const [myFollowers, setMyFollowers] = useState([]);
  const [totalFollowers, setTotalFollowers] = useState(0);
  const [totalFollowing, setTotalFollowing] = useState(0);
  const [about, setAbout] = useState();

  const account_type = state?.userInfo?.account_type;
  const isLoggedInUser = isLoggedIn && !id && !externalProfileInfo?.username;
  const authUser = state?.userInfo;

  // Effect to update social media account links based on the fetched profile info.
  useEffect(() => {
    // Updating social media account links based on profile data.
    setPosts(profileInfo?.posts);
    setAbout(profileInfo?.about ? profileInfo?.about : "Click pencil icon here to add your info");
    const socialMedia = profileInfo?.social_media;
    const facebook = socialMedia?.facebook;
    const twitter = socialMedia?.twitter;
    const instagram = socialMedia?.instagram;
    const telegram = socialMedia?.telegram;

    setSocialMediaAccounts((initial) => {
      return initial?.map((data) => {
        if (data?.title?.toLowerCase() === "facebook") {
          return { ...data, link: facebook };
        } else if (data?.title?.toLowerCase() === "twitter") {
          return { ...data, link: twitter };
        } else if (data?.title?.toLowerCase() === "instagram") {
          return { ...data, link: instagram };
        } else if (data?.title?.toLowerCase() === "telegram") {
          return { ...data, link: telegram };
        } else return data;
      });
    });
  }, [profileInfo]);

  console.log('Posts: ', posts);

  // Effect to fetch profile details based on the user ID or username.
  useEffect(() => {

    if (discoverUserInfo) {
      setProfileInfo(discoverUserInfo);
      return;
    }

    if (props?.editable && !externalProfileInfo?.username) {
      const userInfo = state?.userInfo;
      setProfileInfo(userInfo);
      return;
    }

    const getFullProfileDetails = async () => {
      let actualExternalUser = discoverUserInfo ? discoverUserInfo : externalProfileInfo 
      let getId = id ? id : actualExternalUser?.username;
      
      if (id) {
        return http.get(AUTH_ROUTES.GET_PROFILE_DETAILS_WITHOUT_AUTH(id));
        
      }
      console.log('discoverUserInfo1: ', discoverUserInfo);
      return http.get(AUTH_ROUTES.GET_PROFILE_DETAILS(getId, account_type));
      
    };

    getFullProfileDetails()
      .then(({ data }) => {
        setProfileInfo(data?.data);
      })
      .catch(() => null);
  }, [externalProfileInfo?.username, state, refresh]);

  const following = profileInfo?.followers?.find(
    (follower) => follower?.follower?.id === state?.userInfo?.id
  );

  // const handleFollow = async (userId) => {
  //   if (!isLoggedIn) {
  //     window.location.href = "/";
  //     return;
  //   }
  //   LoadingMessage();

  //   setBtnLoading(true);
  //   const formData = new FormData();
  //   formData.append("user_id", userId);
  //   following
  //     ? await unFollow(formData, account_type, setBtnLoading)
  //     : await follow(formData, account_type, setBtnLoading);
  //   setRefresh({});
  // };

  

  const handleMessageUser = (user) => {
    if (!isLoggedIn) {
      window.location.href = "/";
      return;
    }

    navigate("/messaging", {
      state: { privateChatRecipient: { user } },
    });
  };

  useEffect(() => {
    if (profileInfo?.id) {
      const fetchData = async () => {
        const followingRes = await getFollowingUsers(profileInfo.id);
        setAllFollowingUsers(followingRes?.data?.data);
  
        const followersRes = await getMyfollowers(profileInfo.id);
        setMyFollowers(followersRes?.data?.data);
      };
      setTotalFollowers(profileInfo?.total_followers)
      setTotalFollowing(profileInfo?.total_following)
  
      fetchData();
    }
  }, [profileInfo?.id, totalFollowers, totalFollowing]);

  const handleFollow = async (userIdToRemove) => {
    // Filter out the user with the given ID from the list
    //const updatedFollowingUsers = myFollowers.filter((user) => user?.id !== userIdToRemove);
    const res = await follow(userIdToRemove, setBtnLoading)
    // if (res) {
    //   setMyFollowers(updatedFollowingUsers);
    // }
  };

  const handleUnfollow = async (userIdToRemove) => {
    // Filter out the user with the given ID from the list
    const updatedFollowingUsers = allFollowingUsers.filter((user) => user?.id !== userIdToRemove);
    const res = await unFollow(userIdToRemove, setBtnLoading)
    if (res) {
      setAllFollowingUsers(updatedFollowingUsers);
    }
    
  }

  
  ////////////////////////////////////////////////

  const textColor1 = useColorModeValue("#2F2F2F", "#FCFCFC");
  const textColor2 = useColorModeValue("#7E838D", "#fff");
  const textColor3 = useColorModeValue("#7E838D", "#fff");
  const textColor4 = useColorModeValue("#656464", "#FCFCFC");
  const textColor5 = useColorModeValue("#302E2E", "#FFF");

  const borderColor = useColorModeValue("#181818", "#707070");

  const btnStyle = {
    p: "5px 10px",
    alignItems: "center",
    borderRadius: "5px",
    color: "#fff",
    direction: "row",
    cursor: "pointer",
  };

  const btnStyle2 = {
    p: "5px 17px",
    alignItems: "center",
    borderRadius: "5px",
    color: "#fff",
    direction: "row",
    cursor: "pointer",
  };

  const updateAboutData = async (aboutData) => {
    
    // Check if aboutData is not empty and contains the "about" field
    if (aboutData) {
      const formData1 = new FormData();
      formData1.append("about", aboutData);
      // const formData = {
      //   about: aboutData
      // };
      //console.log('formData: ', formData);
      //console.log('formJson: ', JSON.stringify(formData));
      try {
        let res = await http.post(AUTH_ROUTES.UPDATE_ABOUT, formData1);
        setAbout(res?.data?.about);
        console.log('aboutRes: ', res);
        setEditAbout(false);
        props?.setRefresh({});
      } catch (error) {
        // Handle the error here, e.g., display an error message to the user
        console.error("Error updating about data:", error);
      }
    } else {
      // Handle the case where aboutData or aboutData.about is missing
      console.error("Missing 'about' field in aboutData");
    }
  };
  


  const updateCoverImg = async (img) => {
    const formData = new FormData();
    formData.append("cover_picture", img);

    await http.post(AUTH_ROUTES.UPDATE_COVER_IMAGE, formData);

    props?.setRefresh({});
  };

  const updateSocialMediaData = async (formValues) => {
    // const facebook = socialMediaAccounts?.find(
    //   (data) => data?.title === "Facebook"
    // )?.link;
    // const twitter = socialMediaAccounts?.find(
    //   (data) => data?.title === "Twitter"
    // )?.link;
    // const instagram = socialMediaAccounts?.find(
    //   (data) => data?.title === "Instagram"
    // )?.link;
    // const telegram = socialMediaAccounts?.find(
    //   (data) => data?.title === "Telegram"
    // )?.link;

    const socialMediaLinks = {
      facebook: formValues?.facebook,
      twitter: formValues?.twitter,
      instagram: formValues?.instagram,
      telegram: formValues?.telegram,
    };

    await http.post(AUTH_ROUTES.UPDATE_SOCIAL_MEDIA, socialMediaLinks);

    setEditSocialMedia(false);
    props?.setRefresh({});
  };
  const uploadImg = async (fileName, file) => {
    if (!file) return;
    LoadingMessage("Please wait...");
    const formData = new FormData();
    formData.append(fileName, file);
    await http.post(AUTH_ROUTES.UPLOAD_POST, formData);
    props?.setRefresh({});
    setRefresh({});
  };
  const handleUpdatePost = async (id, file) => {
    if (!file) return;

    LoadingMessage("Please wait...");
    const formData = new FormData();
    formData.append("file", file);
    formData.append("_method", "PUT");

    await http.post(AUTH_ROUTES.UPDATE_POST(id), formData);
    props?.setRefresh({});
    setRefresh({});
    setIsUpdatePost(null);
  };

  return (
    <>
    <Stack
      fontSize={".8em"}
      color={"#7E838D"}
      px={id && !isLoggedIn ? ["0px", "0px", "0px", "70px"] : "initial"}
    >
      <ProfileBox position="relative">
        <Box
          m="-15px -40px"
          h="200px"
          mb="10px"
          borderRadius={"6px"}
          bg={
            profileInfo?.cover_picture
              ? `url(${profileInfo?.cover_picture})`
              : "linear-gradient(90deg, rgba(63,94,251,1) 0%, rgba(102,89,221,1) 39%, rgba(118,87,209,1) 56%, rgba(252,70,107,1) 100%)"
          }
        />
        
        {props?.editable && (
          <>
            <BsPencil
              style={{ position: "absolute", right: "20px", top: "5px" }}
              cursor={"pointer"}
              onClick={() => imageRef.current.click()}
              color="#fff"
            />
            <Text
              style={{ position: "absolute", right: "50%", top: "20%" }}
              color="#fff"
            >{profileInfo?.cover_picture ? null : "1087 x 200"}</Text>
          </>
        )}
        <input
          ref={imageRef}
          onChange={
            (e) => {
              updateCoverImg(e.target.files?.[0]);
            }
          }
          type="file"
          accept="image/*"
          style={{ display: "none" }}
        />
        <Stack direction={["column", "row"]} justifyContent="space-between">
          <Stack mt="-70px">
            <Stack direction={"row"} spacing="30px">
              <Image
                borderRadius={"50%"}
                w="100px"
                maxW="100px"
                maxH="100px"
                h="100px"
                fallbackSrc={thelogo}
                src={profileInfo?.picture}
                objectFit="cover"
                size={"xl"}
                border="4px solid #fff"
              />
              <Stack direction={"row"} alignItems="center" spacing={"50px"}>
                <Stack spacing={"-0.5"} alignSelf={"flex-end"} cursor={"pointer"}
                  onClick={() => {
                    if ((profileInfo?.total_followers > 0) && (myFollowers?.length > 0)) {
                      setFollowersModalOpen(true);
                    }
                  }}
                >
                  <Text
                    fontWeight={"600"}
                    color={textColor5}
                    alignSelf="center"
                  >
                    {nFormatter(profileInfo?.total_followers) || 0}
                  </Text>
                  <Text fontSize={".8em"}>Followers</Text>
                </Stack>
                <Stack spacing={"-0.5"} alignSelf={"flex-end"} cursor={"pointer"}
                  onClick={() => {
                    if ((profileInfo?.total_following > 0) && (allFollowingUsers?.length > 0) ) {
                      setFollowingModalOpen(true);
                    }
                  }}
                >
                  <Text
                    fontWeight={"600"}
                    color={textColor5}
                    alignSelf="center"
                  >
                    {nFormatter(profileInfo?.total_following) || 0}
                  </Text>
                  <Text fontSize={".8em"}>Following</Text>
                </Stack>
              </Stack>
            </Stack>
            <Stack>
              <Text fontWeight={"400"} color={textColor1} fontSize={"1.2em"}>
                {profileInfo?.name || ""}
              </Text>
              <Stack color={textColor2} direction="row" alignItems={"center"}>
                <Text>{`@${profileInfo?.username || ""}`} </Text>
                <Text>{`${profileInfo?.state || ""}, ${
                  profileInfo?.country || ""
                }`}</Text>
              </Stack>
            </Stack>
            <Stack maxW="400px" pb="20px">
              <Text fontWeight={"400"} color={textColor1} fontSize={"1.2em"}>
                About:
              </Text>
              {!editAbout ? (
                <Stack direction={"row"} alignItems="flex-start">
                  <Text maxW="350px" fontSize=".8em">
                    {about}
                  </Text>
                  {props.editable && (
                    <BsPencil
                      cursor={"pointer"}
                      onClick={() => setAboutModalOpen(true)}
                      color="#8E8E8E"
                    />
                  )}
                </Stack>
              ) : (
                <Stack direction={"row"} alignItems="flex-start">
                  <Textarea
                    rows={"9"}
                    fontSize=".8em"
                    w="400px"
                    p="0"
                    resize={"none"}
                    bg="transparent"
                    onChange={(e) => setAbout(e.target.value)}
                  >
                    {about}
                  </Textarea>
                  <IoMdCheckmark
                    cursor={"pointer"}
                    onClick={updateAboutData}
                    color="#8E8E8E"
                  />
                </Stack>
              )}
            </Stack>
          </Stack>

          <Stack>
            {props.editable && isLoggedInUser ? (
              <Stack direction={"row"} justifyContent="space-between" mb="20px">
                <Stack
                  bg="#005FFF"
                  {...btnStyle}
                  onClick={() => props?.setCurrentTab(1)}
                >
                  <AiOutlineSetting fontSize={"1.5em"} />
                  <Text>Settings</Text>
                </Stack>
                <Stack
                  bg="#07900C"
                  {...btnStyle}
                  onClick={() => props?.setCurrentTab(2)}
                >
                  <BsCheckCircle fontSize={"1.5em"} />
                  <Text>Get Verified</Text>
                </Stack>
              </Stack>
            ) : (
              <Stack direction={"row"} justifyContent="space-between" mb="20px">
                <Stack
                  bg="#005FFF"
                  {...btnStyle2}
                  onClick={() => {
                    handleFollow(profileInfo?.id);
                  }}
                >
                  <AiOutlinePlus fontSize={"1.5em"} />
                  <Text>{following ? "Unfolllow" : "Follow"}</Text>
                </Stack>
                <Stack
                  bg="#005FFF"
                  {...btnStyle2}
                  onClick={() => handleMessageUser(profileInfo)}
                >
                  <IoChatbubbles fontSize={"1.5em"} />
                  <Text>Message</Text>
                </Stack>
              </Stack>
            )}
            <Stack flex={2}>
              <style>
                {`
                   .profile-pic:nth-of-type(1) {
                    border-top-left-radius: 10px;
           
                   }
                   .profile-pic:nth-of-type(3) {
                    border-top-right-radius: 10px;
                   }
                   .profile-pic:nth-of-type(4) {
                    border-bottom-left-radius: 10px;
                   }
                    
                   .profile-pic:nth-of-type(6) {
                    border-bottom-right-radius: 10px;
                   }
                    `}
              </style>

              <SimpleGrid columns={3} spacing="10px">
                
                {/* photo1 */}
                <Input
                  type="file"
                  ref={imgRef1}
                  accept="image/jpg, image/jpeg, image/png"
                  display={"none"}
                  onChange={async (e) => {
                    // if (isUpdatePost) {
                    //   await handleUpdatePost(
                    //     posts?.[0]?.id,
                    //     e.target.files?.[0]
                    //   );
                    //   return;
                    // }
                    await uploadImg('photo1', e.target.files?.[0]);
                  }}
                />

                {profileInfo?.photo1 ? (
                  <UpdatePostImageBackground
                    isLoggedIn={isLoggedInUser}
                    //setToggler={setToggler}
                    profileInfo={profileInfo}
                    selectedPhotoIndex={1}
                    onClick={() => {
                      setIsUpdatePost(true);
                      imgRef1?.current?.click();
                    }}
                  >
                    {/* <button onClick={() => setToggler(!toggler)}>
                      Toggle Lightbox
                    </button> */}
                    {/* <FsLightbox
                      toggler={toggler}
                      sources={[
                        'https://i.imgur.com/fsyrScY.jpg',
                        'https://www.youtube.com/watch?v=3nQNiWdeH2Q',
                        'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
                      ]}
                    /> */}
                    
                    <Image
                      w="70px"
                      h="70px"
                      maxW="70px"
                      objectFit={"cover"}
                      className="profile-pic"
                      src={profileInfo?.photo1}
                      //onClick={() => setToggler(!toggler)}
                    />
                    
                  </UpdatePostImageBackground>
                ) : isLoggedInUser ? (
                  <BiImageAdd
                    fontSize={"7em"}
                    cursor={"pointer"}
                    onClick={() => imgRef1?.current?.click()}
                  />
                ) : (
                  <Image
                    w="70px"
                    h="70px"
                    maxW="70px"
                    objectFit={"cover"}
                    className="profile-pic"
                    fallbackSrc="https://via.placeholder.com/150"
                  />
                )}

                {/* photo2 */}
                <Input
                  type="file"
                  ref={imgRef2}
                  accept="image/jpg, image/jpeg, image/png"
                  display={"none"}
                  onChange={async (e) => {
                    // if (isUpdatePost) {
                    //   await handleUpdatePost(
                    //     posts?.[1]?.id,
                    //     e.target.files?.[0]
                    //   );
                    //   return;
                    // }
                    await uploadImg('photo2', e.target.files?.[0]);
                  }}
                />
                {profileInfo?.photo2 ? (
                  <UpdatePostImageBackground
                    isLoggedIn={isLoggedInUser}
                    profileInfo={profileInfo}
                    selectedPhotoIndex={2}
                    onClick={() => {
                      setIsUpdatePost(true);
                      imgRef2?.current?.click();
                    }}
                  >
                    <Image
                      w="700px"
                      h="70px"
                      maxW="70px"
                      objectFit={"cover"}
                      className="profile-pic"
                      src={profileInfo?.photo2}
                    />
                  </UpdatePostImageBackground>
                ) : isLoggedInUser ? (
                  <BiImageAdd
                    fontSize={"7em"}
                    cursor={"pointer"}
                    onClick={() => imgRef2?.current?.click()}
                  />
                ) : (
                  <Image
                    w="70px"
                    h="70px"
                    maxW="70px"
                    objectFit={"cover"}
                    className="profile-pic"
                    fallbackSrc="https://via.placeholder.com/150"
                  />
                )}

                {/* photo3 */}
                <Input
                  type="file"
                  ref={imgRef3}
                  accept="image/jpg, image/jpeg, image/png"
                  display={"none"}
                  onChange={async (e) => {
                    // if (isUpdatePost) {
                    //   await handleUpdatePost(
                    //     posts?.[2]?.id,
                    //     e.target.files?.[0]
                    //   );
                    //   return;
                    // }
                    await uploadImg('photo3', e.target.files?.[0]);
                  }}
                />
                {profileInfo?.photo3 ? (
                  <UpdatePostImageBackground
                    id={id}
                    isLoggedIn={isLoggedInUser}
                    profileInfo={profileInfo}
                    selectedPhotoIndex={3}
                    onClick={() => {
                      setIsUpdatePost(true);
                      imgRef3?.current?.click();
                    }}
                  >
                    <Image
                      w="70px"
                      h="70px"
                      maxW="70px"
                      objectFit={"cover"}
                      className="profile-pic"
                      src={profileInfo?.photo3}
                    />
                  </UpdatePostImageBackground>
                ) : isLoggedInUser ? (
                  <BiImageAdd
                    fontSize={"7em"}
                    cursor={"pointer"}
                    onClick={() => imgRef3?.current?.click()}
                  />
                ) : (
                  <Image
                    w="70px"
                    h="70px"
                    maxW="70px"
                    objectFit={"cover"}
                    className="profile-pic"
                    fallbackSrc="https://via.placeholder.com/150"
                  />
                )}

                {/* photo4 */}
                <Input
                  type="file"
                  ref={imgRef4}
                  accept="image/jpg, image/jpeg, image/png"
                  display={"none"}
                  onChange={async (e) => {
                    // if (isUpdatePost) {
                    //   await handleUpdatePost(
                    //     posts?.[3]?.id,
                    //     e.target.files?.[0]
                    //   );
                    //   return;
                    // }
                    await uploadImg('photo4', e.target.files?.[0]);
                  }}
                />
                {profileInfo?.photo4 ? (
                  <UpdatePostImageBackground
                    isLoggedIn={isLoggedInUser}
                    profileInfo={profileInfo}
                    selectedPhotoIndex={4}
                    onClick={() => {
                      setIsUpdatePost(true);
                      imgRef4?.current?.click();
                    }}
                  >
                    <Image
                      w="70px"
                      h="70px"
                      maxW="70px"
                      objectFit={"cover"}
                      className="profile-pic"
                      src={profileInfo?.photo4}
                    />
                  </UpdatePostImageBackground>
                ) : isLoggedInUser ? (
                  <BiImageAdd
                    fontSize={"7em"}
                    cursor={"pointer"}
                    onClick={() => imgRef4?.current?.click()}
                  />
                ) : (
                  <Image
                    w="70px"
                    h="70px"
                    maxW="70px"
                    objectFit={"cover"}
                    className="profile-pic"
                    fallbackSrc="https://via.placeholder.com/150"
                  />
                )}

                {/* photo5 */}
                <Input
                  type="file"
                  ref={imgRef5}
                  accept="image/jpg, image/jpeg, image/png"
                  display={"none"}
                  onChange={async (e) => {
                    // if (isUpdatePost) {
                    //   await handleUpdatePost(
                    //     posts?.[4]?.id,
                    //     e.target.files?.[0]
                    //   );
                    //   return;
                    // }
                    await uploadImg('photo5', e.target.files?.[0]);
                  }}
                />
                {profileInfo?.photo5 ? (
                  <UpdatePostImageBackground
                    isLoggedIn={isLoggedInUser}
                    profileInfo={profileInfo}
                    selectedPhotoIndex={5}
                    onClick={() => {
                      setIsUpdatePost(true);
                      imgRef5?.current?.click();
                    }}
                  >
                    {" "}
                    <Image
                      w="70px"
                      h="70px"
                      maxW="70px"
                      objectFit={"cover"}
                      className="profile-pic"
                      src={profileInfo?.photo5}
                    />
                  </UpdatePostImageBackground>
                ) : isLoggedInUser ? (
                  <BiImageAdd
                    fontSize={"7em"}
                    cursor={"pointer"}
                    onClick={() => imgRef5?.current?.click()}
                  />
                ) : (
                  <Image
                    w="70px"
                    h="70px"
                    maxW="70px"
                    objectFit={"cover"}
                    className="profile-pic"
                    fallbackSrc="https://via.placeholder.com/150"
                  />
                )}

                {/* photo6 */}
                <Input
                  type="file"
                  ref={imgRef6}
                  accept="image/jpg, image/jpeg, image/png"
                  display={"none"}
                  onChange={async (e) => {
                    // if (isUpdatePost) {
                    //   await handleUpdatePost(
                    //     posts?.[5]?.id,
                    //     e.target.files?.[0]
                    //   );
                    //   return;
                    // }
                    await uploadImg('photo6', e.target.files?.[0]);
                  }}
                />
                {profileInfo?.photo6 ? (
                  <UpdatePostImageBackground
                    isLoggedIn={isLoggedInUser}
                    profileInfo={profileInfo}
                    selectedPhotoIndex={6}
                    onClick={() => {
                      setIsUpdatePost(true);
                      imgRef6?.current?.click();
                    }}
                  >
                    <Image
                      w="70px"
                      h="70px"
                      maxW="70px"
                      objectFit={"cover"}
                      src={profileInfo?.photo6}
                      fallbackSrc="https://via.placeholder.com/150"
                      className="profile-pic"
                    />
                  </UpdatePostImageBackground>
                ) : isLoggedInUser ? (
                  <BiImageAdd
                    fontSize={"7em"}
                    cursor={"pointer"}
                    onClick={() => imgRef6?.current?.click()}
                  />
                ) : (
                  <Image
                    w="70px"
                    h="70px"
                    maxW="70px"
                    objectFit={"cover"}
                    className="profile-pic"
                    fallbackSrc="https://via.placeholder.com/150"
                  />
                )}
              </SimpleGrid>
            </Stack>

          </Stack>
        </Stack>
      </ProfileBox>
      <ProfileBox>
        <Stack mb="15px">
          <Text fontWeight={"400"} color={textColor1} fontSize={"1.2em"}>
            Interest
          </Text>
          <Stack direction={"row"} spacing="30px">
            {profileInfo?.interest?.map((data, id) => (
              <Text
                key={id}
                color={textColor3}
                p="5px 10px "
                border={`1px solid ${borderColor}`}
              >
                {data}
              </Text>
            ))}
          </Stack>
        </Stack>
        <Stack>
          <Stack direction={"row"} alignItems="center">
            {" "}
            <Text fontWeight={"400"} color={textColor1} fontSize={"1.2em"}>
              Social Media{" "}
            </Text>
            {props.editable &&
              (editSocialMedia === false ? (
                <BsPencil
                  cursor={"pointer"}
                  onClick={() => setSocialMediaModalOpen(true)}
                  color="#8E8E8E"
                />
              ) : (
                <IoMdCheckmark
                  cursor={"pointer"}
                  onClick={() => setSocialMediaModalOpen(true)}
                  color="#8E8E8E"
                />
              ))}
          </Stack>

          <Stack
              direction={"row"}
              flexWrap={["wrap", "nowrap"]}
              spacing="30px"
            >
              <Stack
                direction={"row"}
                flexWrap={["wrap", "nowrap"]}
                spacing="30px"
              >
                <Text color={"#0076FF"}>
                  <a
                    href={profileInfo?.social_media?.facebook}
                    target="_blank"
                    style={{ cursor: "pointer" }}
                  >
                    Facebook
                  </a>{" "}
                </Text>
                <Text color={"#E12784"}>
                  <a
                    href={profileInfo?.social_media?.instagram}
                    target="_blank"
                    style={{ cursor: "pointer" }}
                  >
                    Instagram
                  </a>{" "}
                </Text>
                <Text color={"#00C2FF"}>
                  <a
                    href={profileInfo?.social_media?.twitter}
                    target="_blank"
                    style={{ cursor: "pointer" }}
                  >
                    Twitter
                  </a>{" "}
                </Text>
                <Text color={"#009274"}>
                  <a
                    href={profileInfo?.social_media?.telegram}
                    target="_blank"
                    style={{ cursor: "pointer" }}
                  >
                    Telegram
                  </a>{" "}
                </Text>
              </Stack>
            </Stack>
        </Stack>
      </ProfileBox>

      <ProfileBox>
        <Stack maxW="300px">
          <Text fontWeight={"400"} color={textColor1} fontSize={"1.2em"}>
            My Groups
          </Text>
          <Stack direction={"columns"} flexWrap="wrap">
            {profileInfo?.groups?.map((data, id) => (
              <MyGroupCard group={data} key={id} authUser={authUser} profileInfo={profileInfo} />
            ))}
          </Stack>
        </Stack>
        {!props.editable ||
          (!id && (
            <Box
              p="5px 10px"
              cursor={"pointer"}
              borderRadius={"5px"}
              bg="#FF0000"
              color="#fff"
              alignSelf={"flex-end"}
              mr="-30px !important"
              mb="-5px !important"
              display={"none"}
            >
              Report this User
            </Box>
          ))}
      </ProfileBox>

      <AboutModal updateAboutData={updateAboutData} about={about} isOpen={aboutModalOpen} onClose={() => setAboutModalOpen(false)} />
      <FollowersModal authUserId={profileInfo?.id} myFollowers={myFollowers} handleFollow={handleFollow} isOpen={followersModalOpen} onClose={() => setFollowersModalOpen(false)} />
      <FollowingModal authUserId={profileInfo?.id} allFollowingUsers={allFollowingUsers} handleUnfollow={handleUnfollow} isOpen={followingModalOpen} onClose={() => setFollowingModalOpen(false)} />
      <SocialMediaModal updateSocialMediaData={updateSocialMediaData} socialMedia={profileInfo?.social_media} isOpen={socialMediaModalOpen} onClose={() => setSocialMediaModalOpen(false)} />

    </Stack>

    </>
  );
}

export default ProfileOverview;
